// extracted by mini-css-extract-plugin
export default {"grid":"NumberPad_grid__ElqQC","gridTwoRows":"NumberPad_gridTwoRows__q5pv-"};